export default class Routes {
  static CLIENTE = "/cliente";
  static CLIENTE_PEDIDOS = "/cliente/pedidos";
  static PRODUTOS_ANUNCIO = "/anuncio/produtos";
  static LISTAS_COMPRAS = "/cliente/listascompras";
  static CARRINHO = "/carrinho"
}
